import { isActivated } from '@openclassrooms/utils/config';
import {
  imagePlaceholderToImage,
  backgroundPlaceholderToBackground,
} from './parsers/ImagesCdnParser';

function imageCdn() {
  const isEnabled = isActivated('cdnImage');
  imagePlaceholderToImage({ disableCdn: !isEnabled });
  backgroundPlaceholderToBackground({ disableCdn: !isEnabled });
}

export default {
  name: 'imageCdn',
  init: imageCdn,
};
